module.exports = __webpack_public_path__ + "img/jieshao_img.46d333ed.png";